import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import logoImage from "../../../static/images/Hommey_Brandmark_Black_RGB.png"
import tw from "twin.macro"

import { withBrand } from "./withBrand"
import styled from "@emotion/styled"

const Logo = styled(GatsbyImage)`
  ${tw`w-full`}
  ${({ rounded }) => (rounded ? tw`rounded-1` : null)}
`

const HeaderLogo = styled("img")`
  ${tw`w-full`}
`
export const Brand = withBrand(({ brand }) => {
  const rounded = brand?.childImageSharp?.gatsbyImageData?.images?.fallback?.src.includes("afterpay-badge-blackonmint.png")

  return brand && rounded ? (
    <Logo image={brand?.childImageSharp?.gatsbyImageData} alt="Hommey" title="Hommey" fadeIn={false} loading={"eager"} rounded={rounded} />
  ) : (
    <HeaderLogo src={logoImage} alt="Hommey" title="Hommey" />
  )
})
